import cx from 'classnames';
import React from 'react';

import Location from './Location';
import { useLocationContext } from '../../context/LocationContext';

export default function CityStateInfo() {
  const {
    errorState,
    city,
    isDeliveryAllowed = true,
    isExcludedLocation
  } = useLocationContext();

  if ((!city && errorState.locationError) || isExcludedLocation) return null;

  return (
    <div
      data-qa="city-state-info"
      data-testid="city-state-info"
      className={cx(
        'w-11/12 text-center s:max-m:pb-32 m:border-0 m:border-b m:border-solid m:border-grey-2 m:p-24 m:pb-[26px]',
        {
          'm:pb-4': !isDeliveryAllowed,
          'm:border-b-0': !isDeliveryAllowed,
          'm:border-t': !isDeliveryAllowed
        }
      )}
    >
      <p className="m-0 text-grey-5 tl-body-s">
        Options for getting your vehicle in:
      </p>
      <Location />
    </div>
  );
}
